export const PDF_FIELD_MAPPINGS: Record<string, string | null> = {
  // Time fields - handled specially with year/month split
  'text-employeeroleyear': 'timeInRoleYears',
  'text-employeerolemonth': 'timeInRoleMonths',
  'text-employeelevelyear': 'timeInLevelYears',
  'text-employeelevelmonth': 'timeInLevelMonths',
  'text-employeeamazonyear': 'timeInAmazonYears',
  'text-employeeamazonmonth': 'timeInAmazonMonths',

  // Job fields
  'text-employeejobcat': 'technicalClassification',
  'text-employeejobrole': 'jobFamily',
  'text-jobhistory': 'formattedJobHistory',

  // Summary fields
  'text-rolesummary': 'formattedRoleSummary',
  'text-primaryownership': 'formattedPrimaryOwnership',
  'text-justjfications': 'formattedJustification',

  // Calculated fields
  'text-talentcardperiod': 'talentCardPeriod',

  // Checkboxes - handled separately
  'checkbox-manager': 'isManager',
  'checkbox-barraiser': 'isBarRaiser'
};

export const MAX_EMPLOYEES = 200;
export const BATCH_SIZE = 5;
export const BATCH_DELAY_MS = 500;
export const API_TIMEOUT_MS = 5000;
